import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    api: 'https://info-sites.mskobr.ru',
    token: false,
    eoId: false,
    // path: 'http://info-sites.mskobr.ru/app_dev.php/api/labors.json',
    path: '/api/labors.json',
    uploadPath: '/api/labors/uploads/files.json',
    deletePath: '/api/labor/file.json',
    folders: false,
    selectFolder: false,
    selectFile: false
  },
  mutations: {
    setToken (state, value) {
      state.token = value
    },
    setEoId (state, value) {
      state.eoId = value
    },
    setFolders (state, value) {
      state.folders = value
    },
    setSelectFolder (state, value) {
      state.selectFolder = value
    },
    setSelectFile (state, value) {
      state.selectFile = value
    }
  },
  actions: {
    getFolders ({ state, commit }) {
      let path = state.api + state.path + '?eoId=' + state.eoId
      Axios({
        method: 'get',
        url: path
      }).then((res) => {
        if (res.data.response === 'success') {
          commit('setFolders', res.data.result)
        }
      })
    },
    deleteFile ({ state, commit }) {
      let path = state.api + state.deletePath
      Axios({
        method: 'DELETE',
        url: path,
        data: {
          token: state.token,
          folder: state.selectFolder,
          id: state.selectFile,
          eoId: state.eoId
        },
        headers: {
          'accept': 'json',
          'Content-Type': 'application/json'
        }
      })
    }
  }
})
